'use strict';

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _shuffle = require('lodash/shuffle');

var _shuffle2 = _interopRequireDefault(_shuffle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.addEventListener('DOMContentLoaded', function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(event) {
    var relatedPostsContainer, articleId, relatedTag, blogArticlesUrl;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            relatedPostsContainer = document.querySelector('#related-posts');

            if (!relatedPostsContainer) {
              _context.next = 7;
              break;
            }

            articleId = Number(relatedPostsContainer.dataset.articleId);
            relatedTag = relatedPostsContainer.dataset.relatedTag;

            // Fetch the articles

            blogArticlesUrl = '/blogs/the-truth?view=json';
            _context.next = 7;
            return fetch(blogArticlesUrl).then(function (response) {
              return response.json();
            }).then(function (articles) {
              // Filter for related articles
              var relatedArticles = articles.filter(function (article) {
                return (
                  // article.tags.includes(relatedTag) && article.id !== articleId
                  article.id !== articleId
                );
              }).map(function (article) {
                return article.vertical_card_markup;
              });

              // Randomize the article order
              var shuffledRelatedArticles = (0, _shuffle2.default)(relatedArticles);
              var twoRelatedArticles = shuffledRelatedArticles.slice(0, 2);

              // Insert into the DOM
              relatedPostsContainer.innerHTML = twoRelatedArticles.join('');
            });

          case 7:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function (_x) {
    return _ref.apply(this, arguments);
  };
}()); /*----------------------------
      Scripts
      ----------------------------*/

// Imports